import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
,  standalone: false
})
export class ThankYouComponent implements OnInit {


  ngOnInit() {
    //This blank function is mandatory.
  }

}
